import type { ComponentType, ReactNode } from 'react';

export const THEME_PRESETS = ['blaze', 'lightspeed'] as const;
export type ThemePreset = (typeof THEME_PRESETS)[number];
export const DEFAULT_THEME_PRESET: ThemePreset = 'blaze';

export function isThemePreset(value: unknown): value is ThemePreset {
  return (
    typeof value === 'string' &&
    (THEME_PRESETS as readonly string[]).includes(value)
  );
}

export interface DashboardLayoutProps {
  header?: ReactNode;
  children: ReactNode;
  fullWidth?: boolean;
}

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

export interface ThemeComponents {
  Layout: ComponentType;
  DashboardLayout: ComponentType<DashboardLayoutProps>;
  PageHeader: ComponentType<PageHeaderProps>;
}

export interface ThemeManifest {
  preset: ThemePreset;
  displayName: string;
  description: string;
  className: string;
  components: ThemeComponents;
}
